import { STORE_KEY } from '../constants';
import type { State } from '../reducers';

export const dialogsSelector = (state: GlobalState) => state[STORE_KEY] as State;
